import PlatformNotificationParamsInterface from "~/operatorApplication/ts/platform/PlatformNotificationParamsInterface";
import Random from "~/ts/library/Random";
import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";

export default abstract class AbstractDesktopPlatformNotificationWindow {
    private _groupId: string;
    private _notificationUid: string;

    public abstract init(): Promise<void>;

    //true - click, false - close, null - открытие другого уведомления
    public async show(p: PlatformNotificationParamsInterface): Promise<boolean | null> {
        this._groupId = p.groupId;
        let notificationUid = Random.uid();
        this._notificationUid = notificationUid;

        return new Promise(async (resolve) => {
            let autoCloseNotificationsEnabled = OperatorApplicationConfigInstance.autoCloseNotificationsEnabled;
            let autoCloseNotificationsDelay = OperatorApplicationConfigInstance.autoCloseNotificationsDelay;
            if (typeof p.autoCloseSeconds == "number") {
                if (p.autoCloseSeconds > 0) {
                    autoCloseNotificationsEnabled = true;
                    autoCloseNotificationsDelay = p.autoCloseSeconds;
                } else {
                    autoCloseNotificationsEnabled = false;
                }
            }
            if (p.disallowAutoClose) {
                autoCloseNotificationsEnabled = false;
            }
            if (autoCloseNotificationsEnabled) {
                setTimeout(() => {
                    if (notificationUid === this.notificationUid) {
                        resolve(false);
                    }
                }, autoCloseNotificationsDelay * 1000);
            }
            let result = await this.applyContentAndDisplay(p);
            if (typeof result === "number" && p.actions) {
                let action = p.actions[result];
                if (action) {
                    action.click();
                }
            }
            resolve(typeof result != "number" ? result : null);
        });

    }

    public abstract close(): void;

    protected abstract applyContentAndDisplay(p: PlatformNotificationParamsInterface): Promise<boolean | number>;

    get groupId(): string {
        return this._groupId;
    }

    get notificationUid(): string {
        return this._notificationUid;
    }

    public abstract setSize(width: number, height: number): void;

    public abstract setPosition(left: number, top: number, animate: boolean): void;
}